import script from "./IncidentReportFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./IncidentReportFormView.vue?vue&type=script&setup=true&lang=js"

import "./IncidentReportFormView.vue?vue&type=style&index=0&id=751d6c0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-751d6c0e"]])

export default __exports__